import './MobileNavigation.scss';
import * as React from 'react';
import Navigation from './Navigation';
type Props = {
  path: string;
  currentPageHeadings: Array<{
    value: string;
    depth: number;
  }>;
  currentHeading: string | undefined | null;
};
type State = {
  expanded: boolean;
};
/**
 * Wraps the navigation component in concealing it with a show / hide toggle.
 */
export default class DocsMobileNavigation extends React.Component<
  Props,
  State
> {
  state = {
    expanded: false,
  };
  onToggleExpanded = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };
  render() {
    const { expanded } = this.state;
    return (
      <div className="DocsMobileNavigation">
        <button
          onClick={this.onToggleExpanded}
          className="DocsMobileNavigation-button"
        >
          {expanded ? 'Hide Navigation' : 'Show Navigation'}
        </button>

        {expanded && (
          <div className="DocsMobileNavigation-content">
            <Navigation {...this.props} />
          </div>
        )}
      </div>
    );
  }
}
